export default __webpack_public_path__ + "static/media/sticker-v.aa6dddf2.png";